import TrainingService from './TrainingService';

//  Actions
const GET = 'training/GET';
const GET_SUCCESS = 'training/GET_SUCCESS';
const GET_ERROR = 'training/GET_ERROR';
const COMPLETE_TASK_SUCCESS = 'training/COMPLETE_TASK_SUCCESS';
const COMPLETE_TASK_ERROR = 'training/COMPLETE_TASK_ERROR';

const defaultState = {
  modules: [],
  loaded: false,
  loading: false,
};

//  Reducer
export default function trainingReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case GET:
      return Object.assign({}, state, { loading: true });
    case GET_SUCCESS:
      return Object
        .assign({}, state, { modules: action.trainingModules, loaded: true, loading: false });
    case GET_ERROR:
      return state;
    case COMPLETE_TASK_SUCCESS:
      const modules = state.modules.map(program => {
        program.trainingModules.map(module => {
          module.submodules.map(submodule => {
            submodule.tasks.map(task => {
              if (task.id === action.module.trainingTaskId) {
                task.completed = action.module.completed;
              }
              return task;
            });
            return submodule;
          })
        return module;
        });
        return program;
      });

      return Object
        .assign({}, state, { modules, loaded: true, loading: false });
    case COMPLETE_TASK_ERROR:
      return state;
    default:
      return state;
  }
}

//  Action Creators
export function getAllTrainingModules() {
  return { type: GET };
}

export function getTrainingModulesSuccess(trainingModules) {
  return { type: GET_SUCCESS, trainingModules };
}

export function getTrainingModulesError(error) {
  return { type: GET_ERROR, error };
}

export function completeTrainingTaskSuccess(module) {
  return { type: COMPLETE_TASK_SUCCESS, module };
}

export function completeTrainingTaskError(task) {
  return { type: COMPLETE_TASK_ERROR, task };
}

//  Action dispatcher functions

export function getTrainingModules(userId) {
  return function (dispatch) {
    dispatch(getAllTrainingModules());
    return TrainingService.getTrainings(userId)
      .then((response) => {
        dispatch(getTrainingModulesSuccess(response));
      })
      .catch((response) => {
        dispatch(getTrainingModulesError(response.data));
      });
  };
}

export function completeTrainingTask(userId, taskId) {
  return function (dispatch) {
    return TrainingService.completeTask(userId, taskId)
      .then((response) => {
        dispatch(completeTrainingTaskSuccess(response));
      })
      .catch((error) => {
        dispatch(completeTrainingTaskError(error.data));
      });
  };
}
